/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Tdaypay
 */
export class Tdaypay {
    /**
     *
     * @type {string}
     * @memberof Tdaypay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Tdaypay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Tdaypay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Tdaypay
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Tdaypay
     */
    merchantId: string;
    /**
     *
     * @type {boolean}
     * @memberof Tdaypay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Tdaypay
     */
    autoApprove: boolean;
}
